var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { Popover } from '@headlessui/react';
import cx from 'classnames';
import { formatDateStringForUI } from './utils';
var DateTimeRangePickerTrigger = function (_a) {
    var range = _a.range, onClick = _a.onClick, isActive = _a.isActive;
    var dateString = isActive && range.from.isRelative()
        ? "".concat(formatDateStringForUI(range.from), " \u2192 ").concat(formatDateStringForUI(range.to))
        : range.getRangeStringForUI();
    return (_jsx(_Fragment, { children: _jsx(Popover.Button, __assign({ onClick: onClick, title: dateString }, { children: _jsxs("div", __assign({ onClick: onClick, className: cx('text-gray-600 dark:text-gray-300 relative flex justify-between min-w-[200px] border-t border-r border-b border-l dark:border-gray-600 rounded-md shadow-sm px-3 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm', { 'bg-gray-50 dark:bg-gray-900': !isActive }, { '!justify-center, bg-gray-100 dark:bg-gray-800': isActive }) }, { children: [_jsx("span", __assign({ className: "w-[147px] xl:w-auto text-ellipsis overflow-hidden whitespace-nowrap" }, { children: dateString })), _jsx("span", __assign({ className: "px-2 cursor-pointer" }, { children: !isActive ? '▼' : '▲' }))] })) })) }));
};
export default DateTimeRangePickerTrigger;
